import { ElementRef, Injectable } from '@angular/core';
import { environment } from 'env/environment';
import { GsiButtonConfiguration } from 'google-one-tap';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { GoogleTokenResponseModel } from 'app/shared/models/google-token-response.model';
import { ExternalScriptService } from './external-script.service';
import { take } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class GoogleSignOnService {
  private token$ = new Subject<GoogleTokenResponseModel>();
  private initializer$ = new ReplaySubject<boolean>();
  private sourceId = '';


  constructor(private readonly scriptService: ExternalScriptService) {
    this.initializeGoogleAccounts();
  }

  private initializeGoogleAccounts(): void {
    this.scriptService.load('google').then(data => {
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: (response) => this.token$.next({
          token: response.credential,
          sourceId: this.sourceId
        })
      });
      this.initializer$.next(true);
    });
  }

  public render(button: ElementRef, options: GsiButtonConfiguration, sourceId: string) {
    this.initializer$.asObservable().pipe(
      take(1),
      untilDestroyed(this)
    )
    .subscribe(_ => this.renderButton(button, options, sourceId));
  }

  public getIdToken(): Observable<GoogleTokenResponseModel> {
    return this.token$.asObservable();
  }

  private renderButton(button: ElementRef, options: GsiButtonConfiguration, sourceId: string) {
    google.accounts.id.renderButton(
      button.nativeElement,
      {
        ...options,
        click_listener: () => this.sourceId = sourceId
      } as GsiButtonConfiguration
    );
  }
}
